// ВЕРСИЯ В АДРЕСЕ СТАТИКИ `public/` — ОДИН ПОМОЩНИК (канон CLAUDE.md «Экран показывается ОДИН РАЗ» п.5; ТЗ
// ~/projects/HELP-WARM-FIX-TZ.md §1 п.6; ТЗ ~/projects/SPEED-TZ.md §6.1, П3). Картинки сцены (`/scene-post/*`, `/landing2/*`,
// `/onboarding-*`), снимки статей справки (`/help/guides/*`), значки-подмены и шрифты получают `?v=<хэш файла>` из
// манифеста `src/generated/asset-manifest.json` (его пишет scripts/asset-manifest.mjs в prebuild), а ответ на адрес с `v` —
// `Cache-Control: public, max-age=31536000, immutable` (next.config.mjs `headers`). Файл не менялся — адрес тот же после
// выкатки, браузер держит его год; поменялся — новый хэш, новый адрес. Файла нет в манифесте (добавлен без пересборки
// манифеста, dev) — запас `?v=<версия сборки>`, как было до 27.10.2026. Старые адреса без `v` работают, как раньше
// (без immutable). Без 'use client': тот же помощник зовут сервер (статьи, страница сцены) и браузер — адрес совпадает.
//
// INVARIANT(scriptera): версию к адресу статики `public/` ставит только `assetUrl`; immutable — только на адрес с `v`.
// Причина: immutable без версии навсегда оставил бы у людей старый файл. Канон: CLAUDE.md «Экран показывается ОДИН РАЗ».
import manifestJson from '@/generated/asset-manifest.json';

/** Версия сборки (та же, что у PWA-обновления); в dev — метка запуска сервера. Запас для файлов вне манифеста. */
export const ASSET_VERSION: string = process.env.NEXT_PUBLIC_BUILD_ID ?? '';

/** Путь файла `public/` → первые 8 знаков sha1 его содержимого. */
export const ASSET_MANIFEST: Readonly<Record<string, string>> = manifestJson;

/** Свой адрес `public/` → с `?v=<хэш файла>` (запас — версия сборки). Чужой адрес, `data:`/`blob:`, уже с `v` или без
 *  хэша и версии сборки — как есть. */
export function assetUrl(src: string): string {
  if (!src.startsWith('/') || src.startsWith('//')) return src;
  if (/[?&]v=/.test(src)) return src;
  const q = src.indexOf('?');
  const path = q < 0 ? src : src.slice(0, q);
  const v = ASSET_MANIFEST[path] ?? ASSET_VERSION;
  if (!v) return src;
  return `${src}${q >= 0 ? '&' : '?'}v=${encodeURIComponent(v)}`;
}
